import React from 'react'
import FuboFreeTemplate from 'src/components/template/fubofree'
import USTemplateDefault from 'src/components/template/us'
import { fanduelSportsNetworkFAQs } from 'src/constants/faqs'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { useCheckFanduelRSN } from 'src/modules/hooks/useCheckFanduelRSN'
import { useFormatFanduelData } from 'src/modules/hooks/useFormatFanduelData'

export default (props) => {
  const { showFDPlanCards, rsnData } = useCheckFanduelRSN()
  const formattedPlan = useFormatFanduelData(usPlanData.fanduel_standalone_monthly, rsnData)
  const commonProps = {
    location: props.location,
    lang: 'en',
    market: 'us',
    poster: 'https://assets-imgx.fubo.tv/marketing/lp/images/posters/fdsn_poster-1.jpg',
    title: 'Watch FanDuel Sports Network',
    subtitle: 'Stream live games and local team coverage. Regional restrictions apply.',
    networkSet: 'sports',
    customNetworks: ['fanduelsports'],
  }

  return showFDPlanCards ? (
    <FuboFreeTemplate
      {...commonProps}
      planCardSubtitle=""
      additionalFAQs={fanduelSportsNetworkFAQs}
      disableFreeTrial={true}
      hasPlanCards={true}
      plansSharedData={{
        rsn: rsnData.rsn,
        teams: rsnData.teams,
      }}
      plans={[
        {
          ...formattedPlan,
          offerCode: rsnData.winbackOfferCode,
          discountedPrice: rsnData?.price ? (rsnData.price - 10).toFixed(2) : null,
          ctaText: 'Save $10',
        },
      ]}
    />
  ) : (
    <USTemplateDefault {...commonProps} />
  )
}
